import React, { useState } from 'react'

import { cn, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import Image from 'next/image'

import ICONS from '@/assets/icons'
import CommentTextarea from '@/app/(global)/post-cre/components/RenderFormComment'
import { ListComment } from '@/app/(global)/feed/[...postId]/components/commentsPost/ListComment'
import { useGetCommentQuery, useGetDetailFeedQuery } from '@/redux/api/feed/feed.w3api'

import { ItemFeed } from '../shared/ContentFeed/CardSS/ItemFeed'
import { ModalSharePost } from './ModalSharePost'

export const PostComment = React.memo(
  ({ isOpen, onOpenChange, postId }: { onOpenChange: () => void; isOpen: boolean; postId: string }) => {
    const { data } = useGetDetailFeedQuery({ id: postId }, { skip: !postId })
    const [isOpenSharePost, setIsOpenSharePost] = useState<boolean>(false)
    const { data: comments } = useGetCommentQuery({ postId, size: 1, page: 0 }, { skip: !postId })

    return (
      <Modal
        className="bg-ss-dark text-ss-grayscale-100"
        hideCloseButton={true}
        size="2xl"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        scrollBehavior="inside"
        backdrop="blur"
        classNames={{
          base: ' max-h-[100%] md:max-h-[calc(100%_-_8rem)] max-md:h-[100%]',
        }}
      >
        <ModalContent>
          <ModalHeader className="flex items-center gap-2">
            <Image
              onClick={onOpenChange}
              className="cursor-pointer"
              src={ICONS.icCloseWhite}
              width={22}
              height={22}
              alt=""
            />
            <h3 className="text-base font-medium text-white">{data?.nickname}&#39;s post </h3>
          </ModalHeader>
          <ModalBody className="px-2">
            <ItemFeed item={data}>
              <ItemFeed.ItemFeedContent>
                <ItemFeed.FeedAction
                  onSharePost={() => {
                    setIsOpenSharePost(true)
                  }}
                  onComment={() => {}}
                  index={0}
                />
              </ItemFeed.ItemFeedContent>
            </ItemFeed>
            <div style={{ height: '1px' }} id="scrollToTop" />
            <ListComment postId={postId} />
          </ModalBody>

          <ModalFooter className={cn(!comments?.meta?.totalPage ? '' : 'border-t border-white/10 py-1 pb-4  ')}>
            <CommentTextarea postId={postId} />
          </ModalFooter>

          <ModalSharePost
            postId={postId}
            isOpen={isOpenSharePost}
            toggleOpen={() => setIsOpenSharePost(!isOpenSharePost)}
          />
        </ModalContent>
      </Modal>
    )
  },
)
